import React from 'react';

import Facebook from '../Icons/Facebook';
import Instagram from '../Icons/Instagram';
import Twitter from '../Icons/Twitter';
import LinkedIn from '../Icons/LinkedIn';
import Weibo from '../Icons/Weibo';

interface SocialMediaIcon {
  id: string;
  href: string;
  availableInROW: boolean;
  availableInChina: boolean;
  icon: JSX.Element;
  ariaLabel: string;
}

const socialMediaLinks: SocialMediaIcon[] = [
  {
    id: 'facebook-link',
    href: 'https://www.facebook.com/intostudy',
    availableInROW: true,
    availableInChina: false,
    icon: <Facebook />,
    ariaLabel: 'link to our Facebook page',
  },
  {
    id: 'instagram-link',
    href: 'https://www.instagram.com/intostudy/',
    availableInROW: true,
    availableInChina: false,
    icon: <Instagram />,
    ariaLabel: 'link to our Instagram page',
  },
  {
    id: 'twitter-link',
    href: 'https://twitter.com/intostudy',
    availableInROW: true,
    availableInChina: false,
    icon: <Twitter />,
    ariaLabel: 'link to our X account page',
  },
  {
    id: 'linked-in-link',
    href: 'https://www.linkedin.com/school/621294/',
    availableInROW: true,
    availableInChina: true,
    icon: <LinkedIn />,
    ariaLabel: 'link to our linked in profile page',
  },
  {
    id: 'weibo-link',
    href: 'https://www.weibo.com/intohigher',
    availableInROW: false,
    availableInChina: true,
    icon: <Weibo />,
    ariaLabel: 'link to our weibo page',
  },
];

interface ISocialMediaIcons {
  chinaVersion: boolean;
}

export default function SocialMediaIcons({ chinaVersion }: ISocialMediaIcons) {
  const icons = socialMediaLinks.filter((icon) =>
    chinaVersion ? icon.availableInChina : icon.availableInROW,
  );
  return (
    <>
      {icons.map((icon, index) => (
        <a
          data-testid={icon.id}
          aria-label={icon.ariaLabel}
          key={`social-media-icon-${index}`}
          href={icon.href}
        >
          {icon.icon}
        </a>
      ))}
    </>
  );
}
